export default "__VITE_ASSET__DnQy2xHK__"